export default "__VITE_ASSET__BQrXOXMz__"